document.addEventListener('DOMContentLoaded', function () {
  // ...existing code...

  // Multi-select popup logic
  var pestInput = document.querySelector('.pest-issues-multiselect');
  var pestIcon = document.querySelector('.pest-issues-multiselect-icon');
  var popupRoot = document.getElementById('pest-issues-popup-root');
  // Get options from Liquid context (rendered as JS array)
  var pestOptions = [];
  try {
    pestOptions = JSON.parse(document.getElementById('pest-issues-options-json').textContent);
  } catch (e) {}

  function renderPestPopup(selected) {
    if (!popupRoot) return;
    // Remove any existing popup overlay
    var old = document.querySelector('.pest-issues-popup-overlay');
    if (old) old.remove();
    // Create overlay
    var overlay = document.createElement('div');
    overlay.className = 'pest-issues-popup-overlay';
    // Popup box
    var popup = document.createElement('div');
    popup.className = 'pest-issues-popup';
    // Title
    var title = document.createElement('div');
    title.className = 'pest-issues-popup-title';
    title.textContent = 'Select Pest Issues';
    popup.appendChild(title);
    // List
    var list = document.createElement('div');
    list.className = 'pest-issues-list';
    pestOptions.forEach(function(opt) {
      var label = document.createElement('label');
      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.value = opt;
      if (selected.includes(opt)) checkbox.checked = true;
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(opt));
      list.appendChild(label);
    });
    popup.appendChild(list);
    // Actions
    var actions = document.createElement('div');
    actions.className = 'pest-issues-popup-actions';
    var btnCancel = document.createElement('button');
    btnCancel.textContent = 'Cancel';
    btnCancel.className = 'cancel';
    var btnOk = document.createElement('button');
    btnOk.textContent = 'OK';
    actions.appendChild(btnCancel);
    actions.appendChild(btnOk);
    popup.appendChild(actions);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
    setTimeout(function(){ overlay.classList.add('active'); }, 10);
    // Cancel closes
    btnCancel.onclick = function() {
      overlay.classList.remove('active');
      $(`body`).removeClass(`scroll-hide`);
      setTimeout(function(){ overlay.remove(); }, 300);
    };
    // OK sets value
    btnOk.onclick = function() {
      var checked = Array.from(list.querySelectorAll('input[type=checkbox]:checked')).map(function(cb){ return cb.value; });
      pestInput.value = checked.join(', ');
      // Add class to trigger label float
      if (pestInput.value) {
        pestInput.classList.add('has-value');
      } else {
        pestInput.classList.remove('has-value');
      }
      overlay.classList.remove('active');
      $(`body`).removeClass(`scroll-hide`);
      setTimeout(function(){ overlay.remove(); }, 300);
    };
    // Click outside closes
    overlay.onclick = function(e) {
      if (e.target === overlay) {
        overlay.classList.remove('active');
        $(`body`).removeClass(`scroll-hide`);
        setTimeout(function(){ overlay.remove(); }, 300);
      }
    };
  }
  function openPestPopup() {
    var selected = pestInput.value ? pestInput.value.split(/,\s*/) : [];
    $(`body`).addClass(`scroll-hide`);
    renderPestPopup(selected);
  }
  if (pestInput && pestIcon) {
    pestInput.addEventListener('click', openPestPopup);
    pestIcon.addEventListener('click', openPestPopup);
  }

  // Handle select field label floating
  var selectField = document.querySelector('#warranty-purchase-platform');
  if (selectField) {
    selectField.addEventListener('change', function() {
      if (this.value) {
        this.classList.add('has-value');
      } else {
        this.classList.remove('has-value');
      }
    });
  }

  // Handle "Add Other pest issues" checkbox toggle
  var otherCheckbox = document.querySelector('#warranty-other-checkbox');
  var otherInputWrapper = document.querySelector('#warranty-other-input-wrapper');
  var otherInput = document.querySelector('#warranty-other-input');
  var otherIssuesError = document.querySelector('#other_issues');
  if (otherCheckbox && otherInputWrapper && otherInput) {
    otherCheckbox.addEventListener('change', function() {
      if (this.checked) {
        otherInputWrapper.classList.add('show');
        setTimeout(function() {
          otherInput.focus();
        }, 200);
      } else {
        otherInputWrapper.classList.remove('show');
        otherInput.classList.remove('has-value');
        otherIssuesError.style.display = 'none';
      }
    });
  }

  // Warranty Section JS
  var form = document.querySelector('.warranty-section__form');
  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    // Validation
    var fullName = form.querySelector('[name="full_name"]');
    var email = form.querySelector('[name="email"]');
    var shippingAddress = form.querySelector('[name="shipping_address"]');
    var applicationDate = form.querySelector('[name="application_date"]');

    // Hide all errors first
    var errorFullName = document.getElementById('full_name');
    var errorShipping = document.getElementById('shipping_address');
    var errorAppDate = document.getElementById('application_date');
    var errorOtherInput = document.getElementById('other_issues');
    if (errorFullName) errorFullName.style.display = 'none';
    if (errorShipping) errorShipping.style.display = 'none';
    if (errorAppDate) errorAppDate.style.display = 'none';
    if (errorOtherInput) errorOtherInput.style.display = 'none';

    // Helper to scroll to error element by id, offsetting for header/announcement
    function scrollToErrorEl(errorEl) {
      if (!errorEl) return;
      // Calculate offset for header and announcement bar
      var header = document.querySelector('header');
      var announcement = document.querySelector('.announcement-bar, .shopify-section--announcement-bar');
      var offset = 0;
      if (announcement) offset += announcement.offsetHeight;
      if (header) offset += header.offsetHeight;
      var rect = errorEl.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var top = rect.top + scrollTop - offset - 60; // 60px extra padding
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // Check fields one by one, show first error found and scroll
    if (!fullName.value.trim()) {
      if (errorFullName) {
        errorFullName.style.display = 'inline-flex';
        scrollToErrorEl(errorFullName);
      }
      if (submitBtn) submitBtn.disabled = false;
      return;
    }
    if (!shippingAddress.value.trim()) {
      if (errorShipping) {
        errorShipping.style.display = 'inline-flex';
        scrollToErrorEl(errorShipping);
      }
      if (submitBtn) submitBtn.disabled = false;
      return;
    }
    if (!applicationDate.value.trim()) {
      if (errorAppDate) {
        errorAppDate.style.display = 'inline-flex';
        scrollToErrorEl(errorAppDate);
      }
      if (submitBtn) submitBtn.disabled = false;
      return;
    }
    // Validate otherInput if otherCheckbox is checked
    if (otherCheckbox && otherCheckbox.checked && otherInput && !otherInput.value.trim()) {
      if (errorOtherInput) {
        errorOtherInput.style.display = 'inline-flex';
        scrollToErrorEl(errorOtherInput);
      }
      if (submitBtn) submitBtn.disabled = false;
      return;
    }
    // Get extra fields if selected
    var purchasePlatform = form.querySelector('[name="purchase_platform"]');
    var currentPestIssues = form.querySelector('[name="current_pest_issues"]');
    var otherIssuesInput = form.querySelector('[name="other_issues"]');
    var otherCheckboxChecked = document.querySelector('#warranty-other-checkbox');
    var purchasePlatformValue = purchasePlatform && purchasePlatform.value ? purchasePlatform.value : '';
    var currentPestIssuesValue = currentPestIssues && currentPestIssues.value ? currentPestIssues.value : '';
    var otherIssuesValue = `No other pest issues`;
    
    // Only include other issues if checkbox is checked
    if (otherCheckboxChecked && otherCheckboxChecked.checked) {
      var otherText = otherIssuesInput && otherIssuesInput.value.trim() ? otherIssuesInput.value.trim() : 'No other pest issues';
      otherIssuesValue = otherText;
    }

    // Prepare data for Klaviyo client/subscriptions endpoint
    var properties = {
      shipping_address: shippingAddress.value.trim(),
      application_date: applicationDate.value.trim()
    };
    if (purchasePlatformValue) {
      properties.purchase_platform = purchasePlatformValue;
    }
    if (currentPestIssuesValue) {
      properties.pest_issues = currentPestIssuesValue;
    }
    if (typeof otherIssuesValue != "undefined") {
      properties.other_issues = otherIssuesValue;
    }
    const LIST_ID = "TwtYx7"; // Replace with your actual List ID
    const KLAVIYO_PUBLIC_API_KEY = `Uz4Pdv`;
    // Prepare data for Klaviyo client/subscriptions endpoint

    var klaviyoData = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Two-Month Guarantee Form Submissions',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email.value.trim(),
                first_name: fullName.value.trim().split(' ')[0].trim(),
                last_name: fullName.value.trim().split(' ').slice(1).join(' ').trim(),
                properties: properties,
                subscriptions: {
                  email: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: LIST_ID }
          }
        }
      }
    };
    var url = `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_PUBLIC_API_KEY}`;
    try {
      var response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          revision: '2026-01-15',
        },
        body: JSON.stringify(klaviyoData)
      });
      var text = await response.text();
      let result = null;
      try {
        result = text ? JSON.parse(text) : null;
      } catch (err) {
        return;
      }
      if (response.ok) {
        // Hide the warranty-form-section and show the warranty-success-container
        var container = document.querySelector('#warranty-form-section');
        var containerSuccess = document.querySelector('.warranty-success-container');
        if (container) container.classList.add('visually-hidden');
        if (containerSuccess) {
          containerSuccess.classList.remove('visually-hidden');
          containerSuccess.classList.add('active');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        // Reset the form
        form.reset();
      }
      // Always re-enable submit button after request
      if (submitBtn) submitBtn.disabled = false;
    } catch (error) {
      // No alert or feedback
    }
  });

  // Optional: Add focus effect for icons
  var inputGroups = document.querySelectorAll('.warranty-section__input-group, .warranty-section__select-group');
  inputGroups.forEach(function (group) {
    var input = group.querySelector('input, select');
    var icon = group.querySelector('.warranty-section__icon');
    if (input && icon) {
      input.addEventListener('focus', function () {
        icon.style.opacity = '0.8';
      });
      input.addEventListener('blur', function () {
        icon.style.opacity = '1';
      });
    }
  });

  // Make custom calendar SVG open the datepicker
  var calendarIcon = document.querySelector('.warranty-section__icon--calendar');
  if (calendarIcon) {
    var dateInput = calendarIcon.parentElement.querySelector('input[type="date"]');
    if (dateInput) {
      calendarIcon.style.cursor = 'pointer';
      calendarIcon.addEventListener('click', function (e) {
        e.preventDefault();
        dateInput.focus();
        // For some browsers, trigger click to open picker
        try { dateInput.showPicker && dateInput.showPicker(); } catch (err) { }
      });
    }
  }
});

// jQuery UI Datepicker CDN
var jqueryUiCss = document.createElement('link');
jqueryUiCss.rel = 'stylesheet';
jqueryUiCss.href = 'https://code.jquery.com/ui/1.13.2/themes/base/jquery-ui.css';
document.head.appendChild(jqueryUiCss);

var jqueryUiScript = document.createElement('script');
jqueryUiScript.src = 'https://code.jquery.com/ui/1.13.2/jquery-ui.min.js';
document.head.appendChild(jqueryUiScript);

// Wait for jQuery UI to load before initializing datepicker
function initWarrantyDatepicker() {
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.datepicker === 'undefined') {
    setTimeout(initWarrantyDatepicker, 100);
    return;
  }
  var $dateInput = $('#warranty-application-date');
  if ($dateInput.length) {
    var today = new Date();
    var twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(today.getMonth() - 2);
    var oneMonthForward = new Date();
    oneMonthForward.setMonth(oneMonthForward.getMonth() + 1);
    $dateInput.datepicker({
      dateFormat: 'MM dd, yy',
      minDate: twoMonthsAgo,
      maxDate: oneMonthForward,
      changeMonth: true,
      changeYear: true,
      showAnim: 'fadeIn',
      beforeShow: function (input, inst) {
        setTimeout(function () {
          $(inst.dpDiv).css('z-index', 9999);
        }, 0);
      }
    });
    // Open datepicker on calendar icon click
    $('.warranty-section__icon--calendar').on('click', function (e) {
      e.preventDefault();
      $dateInput.datepicker('show');
    });
  }
}
initWarrantyDatepicker();